export default "__VITE_ASSET__DZowyCMP__"